import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import SingleBtn from 'components/common/elements/SingleBtn';
import ModalWrapper from 'components/common/overlays/ModalWrapper';
import styles from 'styles/components/common/overlays/Modal.module.scss';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import useModal from 'hooks/useModal';

type TProps = {
  isConfirm?: boolean;
  title?: string;
  text: string;
  cancelBtnText?: string;
  submitBtnText?: string;
  onCancel?: () => void;
  onSubmit?: () => void;
};

const Basic = (props: TProps) => {
  const { closeModal } = useModal();

  const cancel = () => {
    closeModal();
    props.onCancel && props.onCancel();
  };

  const submit = () => {
    closeModal();
    props.onSubmit && props.onSubmit();
  };

  return (
    <ModalWrapper>
      {props.title && (
        <header className={styles.title_wrapper}>
          <h2 className={styles.title}>{props.title}</h2>
          <button type="button" onClick={cancel}>
            <CloseIcon fill={STYLES_VARIABLES.GRAY_07} />
          </button>
        </header>
      )}
      <article className={styles.text_wrapper}>
        {props.text.split('\n').map((line, index) => (
          <div key={index}>
            {line.split('카이아이 고객센터').map((inline, i) => {
              return i > 0 ? (
                <div key={i}>
                  <span>카이아이 고객센터&nbsp;</span>
                  <strong>cs01@kai-i.com 또는 1670-2628</strong>
                  <span key={inline}>{inline}</span>
                </div>
              ) : (
                <span key={inline}>{inline}</span>
              );
            })}
          </div>
        ))}
      </article>
      <footer>
        {props.isConfirm && (
          <SingleBtn
            type="button"
            btnText={props.cancelBtnText ?? '취소'}
            hasOutline={true}
            btnStyle={{
              width: 'calc(50% - 5px)',
              marginRight: '10px',
              fontSize: '14px',
            }}
            onClick={cancel}
          />
        )}
        <SingleBtn
          btnText={props.submitBtnText ?? '확인'}
          isBtnActive={true}
          btnStyle={{
            width: props.isConfirm ? 'calc(50% - 5px)' : '100%',
            fontSize: '14px',
          }}
          onClick={submit}
        />
      </footer>
    </ModalWrapper>
  );
};

export default Basic;
